export const ActiveContentSwitcher = {
  extends: ['Grid', 'Navbar'],
  round: 'radiusPill',
  fontSize: 'Z1',
  templateColumns: 'repeat(7, 1fr)',
  align: 'center center',
  children: [
    {
      icon: 'magicstar',
      title: (el) => el.call('polyglot', 'editor.panel.aiAssistant'),
      section: 'AI'
    },
    {
      icon: 'content',
      title: (el) => el.call('polyglot', 'editor.panel.artboards'),
      section: 'ARTBOARD_TYPES'
    },
    {
      icon: 'fnOutline',
      title: (el) => el.call('polyglot', 'editor.panel.functions'),
      section: 'FUNCTION_TYPES'
    },
    {
      icon: 'tree',
      title: (el) => el.call('polyglot', 'editor.ds.title'),
      section: 'DESIGN_SYSTEM_TYPES'
    },
    {
      icon: 'copywritingOutline',
      title: (el) => el.call('polyglot', 'editor.panel.state'),
      section: 'STATE_TYPES'
    },
    {
      icon: 'folderOutline',
      title: (el) => el.call('polyglot', 'editor.panel.assets'),
      section: 'ASSETS_TYPES'
    },
    {
      icon: 'fuse',
      title: (el) => el.call('polyglot', 'editor.panel.integrations'),
      section: 'INTEGRATIONS_TYPES'
    }
  ],
  childProps: {
    textAlign: 'center',
    onClick: (ev, el, s) => {
      const activeContent = el.section
      el.call('setSidebarContent', activeContent)
    }
  },
  childExtends: {
    extends: ['NavbarButton', 'NavbarTooltipParent'],
    state: null,
    width: '100%',
    aspectRatio: 'unset',
    padding: 'Z -',
    // Reviewed (fixed-colour sweep): the literals below are NOT base-level —
    // each is already the return value of its own '@dark'/'@light' factory,
    // so this active-tab pill is a deliberate dark chip in BOTH schemes
    // (gray3 dark / gray4 light background, gray15 text either way), not an
    // unscoped fixed literal. Left as-is.
    '@dark': (el, s) =>
      el.section === s.activeContent
        ? {
            color: 'gray15',
            background: 'gray3'
          }
        : undefined,
    '@light': (el, s) =>
      el.section === s.activeContent
        ? {
            color: 'gray15',
            background: 'gray4'
          }
        : undefined,
    theme: (el, s) => (el.section !== s.activeContent ? 'transparent' : undefined),
    ':hover': (el, s) =>
      el.section !== s.activeContent
        ? {
            '@dark': {
              color: 'gray15',
              background: 'gray2'
            },
            '@light': {
              color: 'gray15',
              background: 'gray4'
            }
          }
        : undefined
  },
  NavbarTooltip: {
    ignoreChildExtends: true,
    ignoreChildProps: true
  }
}
